<template>
    <div>
        <loader v-if="isLoading" />
        <tabs nav-style="tabs" v-model="activeTabIndex">
            <tab header="Report">
                <fieldset :disabled="formDisabledUnlessNew">
                    <form class="form-horizontal" @submit.prevent data-vv-scope="radioCarbonReport">
                        <div class="form-group">
                            <label class="col-md-2 control-label">Lab</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="radioCarbonReport.laboratoryId">
                                    <option value="">Select a value</option>
                                    <option v-for="lab in labList" :value="lab.laboratoryId">
                                        {{lab.name + ' (' + lab.labCode + ')'}}
                                    </option>
                                </select>
                            </div>
                            <label class="col-md-2 control-label">Certainty of Anthropogenic Origin</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="radioCarbonReport.anthropogenicCertaintyId">
                                    <option value="">Select a value</option>
                                    <option v-for="anthroType in anthropogenicCertaintyList" :value="anthroType.anthropogenicCertaintyId">
                                        {{anthroType.description}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label">Lab Number</label>
                            <div class="col-md-4">
                                <input class="form-control" type="text" v-model="radioCarbonReport.laboratoryRefNumber">
                            </div>
                            <label class="col-md-2 control-label">Certainty of Human Event Association</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="radioCarbonReport.humanEventCertaintyId">
                                    <option value="">Select a value</option>
                                    <option v-for="eventType in humanEventCertaintyList" :value="eventType.humanEventCertaintyId">
                                        {{eventType.description}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label">Open/Closed Site</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="radioCarbonReport.isOpen">
                                    <option value="">Select a value</option>
                                    <option value=1>Open</option>
                                    <option value=0>Closed</option>
                                </select>
                            </div>
                            <label class="col-md-2 control-label">Dating Method</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="radioCarbonReport.datingMethodId">
                                    <option value="">Select a value</option>
                                    <option v-for="datingMethod in datingMethodList" :value="datingMethod.datingMethodId">
                                        {{datingMethod.description}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label">Surface/Subsurface Feature</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="radioCarbonReport.isSurface">
                                    <option value="">Select a value</option>
                                    <option value=1>Surface</option>
                                    <option value=0>Subsurface</option>
                                </select>
                            </div>
                            <label class="col-md-2 control-label">Measured Age</label>
                            <div class="col-md-4">
                                <input type="number" min="0" step="1" class="form-control" v-model="radioCarbonReport.measuredAge"/>
                            </div>


                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label">Sample Material</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="radioCarbonReport.radioCarbonSampleTypeId">
                                    <option>Select a Value</option>
                                    <option v-for="sampleType in radioCarbonSampleTypeList" :value="sampleType.radioCarbonSampleTypeId" >
                                        {{sampleType.description}}
                                    </option>
                                </select>
                            </div>

                            <label class="col-md-2 control-label">Conventional Age (mean)</label>
                            <div class="col-md-4">
                                <input type="number" min="0" step="1" class="form-control" v-model="radioCarbonReport.conventionalDateMean"/>
                            </div>

                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label">Sample Material Comment</label>
                            <div class="col-md-4">
                                <input class="form-control" type="text" v-model="radioCarbonReport.sampleComment">
                            </div>

                            <label class="col-md-2 control-label">Conventional Age (error)</label>
                            <div class="col-md-4">
                                <input type="number" min="0" step="1" class="form-control" v-model="radioCarbonReport.conventionalDateError" />
                            </div>


                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label">Bone Dates</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="radioCarbonReport.boneDateTypeId">
                                    <option>Select a Value</option>
                                    <option v-for="boneType in boneDateTypeList" :value="boneType.boneDateTypeId">
                                        {{boneType.description}}
                                    </option>
                                </select>
                            </div>

                            <label class="col-md-2 control-label">13C/12C</label>
                            <div class="col-md-4">
                                <input type="number" step=".1" class="form-control" v-model="radioCarbonReport.carbon1312"/>
                            </div>
                        </div>
                        <div class="form-group" style="margin-top: 10px;" v-if="!formDisabledUnlessNew">
                            <button class="btn btn-primary" v-on:click="saveForm()">Save {{ isNew ? 'and Submit ' : ''}}Report</button>  
                        </div>
                    </form>
                </fieldset>
            </tab>
            <tab v-if="!fromProductionSite" header="Workflow" :disabled="isNew">
                <div style="margin-top: 20px;">
                    <workflow :workflowId="radioCarbonReportWorkflowId" :parentId="radioCarbonReportId" ref="workflow"></workflow>
                </div>
            </tab>
        </tabs>
    </div>        
</template>

<script>
import radioCarbonReportService from '@/services/radioCarbonReportService'
import loggingService from '@/services/util/loggingService'
import laboratoryService from '@/services//laboratoryService'
import workflowService from '@/services/workflowService'

import loader from '@/components/Loader'
import workflow from '@/components/Workflow'
import { tab, tabs } from 'vue-strap'

export default {
    name: 'RadioCarbonReport',
    components: {
        loader,
        workflow,
        tabs,
        tab
    },
    props: {
        formDisabled: { default: true },
        culturalResourceId: { default: null }
    },
    data: function () {
        return {
            activeTabIndex: 0,
            isDebug: false,
            isLoading: true,
            radioCarbonReport: {},
            radioCarbonReportId: null,
            labList: [],
            radioCarbonSampleTypeList: [],
            boneDateTypeList: [],
            anthropogenicCertaintyList: [],
            humanEventCertaintyList: [],
            datingMethodList: [],
            newSaveEventName: 'radioCarbonNewSave'
        }
    },
    mounted () {
        this.loadLookups()
    },
    computed: {
        isNew: function () {
            return !this.radioCarbonReport.radioCarbonReportId
        },
        formDisabledUnlessNew: function () {
            return this.formDisabled && !this.isNew
        },
        radioCarbonReportWorkflowId: function () {
            return workflowService.WorkflowEnum.RadioCarbonReport
        },
        fromProductionSite: function () {
            return !!this.culturalResourceId
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'RadioCarbonReport', message)
        },
        loadLookups () {
            return laboratoryService.list(this.$http).then(result => {
                this.labList = result.data
                this.boneDateTypeList = radioCarbonReportService.getBoneDateTypeList()
                this.anthropogenicCertaintyList = radioCarbonReportService.getAnthropogenicCertaintyList()
                this.humanEventCertaintyList = radioCarbonReportService.getHumanEventCertaintyList()
                this.datingMethodList = radioCarbonReportService.getDatingMethodList()
                this.radioCarbonSampleTypeList = radioCarbonReportService.getRadioCarbonSampleTypeList()
                return result
            })
        },
        loadData (radioCarbonReportId) {
            this.clearData()
            this.tabReset()
            this.isLoading = true
            radioCarbonReportService.get(this.$http, radioCarbonReportId).then(result => {
                this.radioCarbonReport = result.data
                this.radioCarbonReportId = result.data.radioCarbonReportId
                if (this.$refs.workflow) {
                    this.$refs.workflow.loadData()
                }
                this.isLoading = false
            })
        },
        clearData () {
            this.isLoading = false
            this.radioCarbonReport = {}
            this.radioCarbonReportId = null
        },
        createNew (crrId) {
            this.isLoading = false
            this.radioCarbonReport = {
                culturalResourceRecordingId: crrId
            }
        },
        saveForm () {
            //if new report, emit save event and pass reportDto to save at parent level with upload file
            if (this.isNew) {
                this.$emit(this.newSaveEventName, this.radioCarbonReport)
            } else {
                radioCarbonReportService.put(this.$http, this.radioCarbonReport).then(result => {
                    if (result.data.objectList[0]) {
                        this.radioCarbonReport = result.data.objectList[0]
                    }
                })
            }
        },
        tabReset () {
            this.activeTabIndex = 0
        }
    }
}
</script>



// WEBPACK FOOTER //
// RadioCarbonReport.vue?06f582e6